import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-card-appointment-request',
  templateUrl: './card-appointment-request.component.html',
  styleUrls: ['./card-appointment-request.component.scss']
})
export class CardAppointmentRequestComponent implements OnInit {

  type = 'online';
  @Input() withShadow: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
